import type { AccessPermission, EntriliaProduct } from "@entrilia/shared/api/types";
import type { DataImportInfo, DataImportState } from "../../../api/types/dataImportTypes";
import { pageRoutes } from "../../../routes";

export const isImportEditable = (dataImportState: DataImportState): boolean =>
  ["Created", "Parsed"].includes(dataImportState);

export const getDataImportSubpath = ({ id, state }: DataImportInfo): string =>
  `${id}/${isImportEditable(state) ? pageRoutes.importReview : pageRoutes.importDetails}`;

export const getDataImportPagePath = (clientCode: string, dataImport: DataImportInfo): string =>
  `/${clientCode}/${pageRoutes.settings}/${pageRoutes.importData}/${getDataImportSubpath(dataImport)}`;

export const isImportApplicationAllowed = (dataImportState: DataImportState): boolean => dataImportState === "Parsed";

export const isImportOperationRunning = ({
  validationResult,
  applicationResult,
  rollbackResult,
}: DataImportInfo): boolean =>
  validationResult?.isFinished === false ||
  applicationResult?.isCompleted === false ||
  rollbackResult?.isCompleted === false;

export const isImportDeletable = (dataImportState: DataImportState): boolean =>
  !["Applied", "Discarded", "InProgress"].includes(dataImportState);

const productToAccessPermissionMap: Partial<Record<EntriliaProduct, AccessPermission>> = {
  InvestorRelationsManagement: "ManageInvestorRelationsDataImports",
  PortfolioMonitoring: "ManagePortfolioMonitoringDataImports",
  ExpenseManagement: "ManageExpenseManagementDataImports",
};

export const getPermissionsToManageImport = (productAreas: EntriliaProduct[]): AccessPermission[] =>
  productAreas.map((scope) => productToAccessPermissionMap[scope]).filter(Boolean) as AccessPermission[];
